import React from "react";
import { useNavigate } from "react-router-dom";
import { AiFillLock } from "react-icons/ai";
import { motion } from "framer-motion";

const NoAccess = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 px-4">
      <motion.div
        initial={{ opacity: 0, y: 30, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="max-w-md w-full text-center"
      >
        {/* Glass Card */}
        <motion.div
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2, duration: 0.4 }}
          className="backdrop-blur-xl bg-white/40 border border-gray-200 shadow-xl rounded-3xl p-10"
        >
          {/* Animated Lock Icon */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            className="flex justify-center"
          >
            <motion.div
              animate={{ y: [0, -8, 0] }}
              transition={{ repeat: Infinity, duration: 1.8, ease: "easeInOut" }}
              className="w-20 h-20 bg-red-100 text-red-600 rounded-full flex items-center justify-center shadow-lg"
            >
              <AiFillLock className="w-12 h-12" />
            </motion.div>
          </motion.div>

          <h1 className="mt-6 text-3xl font-extrabold text-gray-800 tracking-wide">
            Access Denied
          </h1>

          <p className="mt-3 text-gray-600 text-base leading-relaxed">
            You don’t have permission to view this page.
            <br />
            Contact your administrator for access rights.
          </p>

          {/* Buttons */}
          <div className="mt-8 flex flex-col gap-4">
            <motion.button
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => navigate(-1)}
              className="w-full py-3 bg-gray-900 text-white rounded-xl font-semibold shadow-md hover:shadow-lg transition"
            >
              Go Back
            </motion.button>

            <motion.button
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => navigate("/dashboard")}
              className="w-full py-3 bg-white/70 backdrop-blur-md border border-gray-300 text-gray-800 rounded-xl font-semibold shadow-md hover:bg-white transition"
            >
              Go to Dashboard
            </motion.button>
          </div>
        </motion.div>

        <p className="mt-6 text-sm text-gray-400 tracking-wide">
          SwitchIn — Secure Role-Based Access
        </p>
      </motion.div>
    </div>
  );
};

export default NoAccess;
